import { render, staticRenderFns } from "./TemplateSmsTable.vue?vue&type=template&id=a9dde45c&scoped=true&"
import script from "./TemplateSmsTable.vue?vue&type=script&lang=js&"
export * from "./TemplateSmsTable.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSmsTable.vue?vue&type=style&index=0&id=a9dde45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dde45c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VMenu,VPagination,VRow,VSimpleTable,VTooltip})
